<template>
  <form id="head-img" enctype="multipart/form-data">
    <a href="#" class="upload-avatar-btn" @click.stop.prevent="onPickFile" @mouseover="hover = true" @mouseleave="hover = false">
      <img class="img-avatar img-avatar48 img-avatar-thumb" :src="imageSrcComputed" alt="" />
      <div v-show="hover" class="upload"><i class="fa fa-fw fa-cloud-upload-alt"></i></div>
      <div class="loader" v-if="loading === true"><b-spinner></b-spinner></div>
    </a>
    <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked" />
  </form>
</template>
<script>
import mixin from "../../mixins/mixin";
import Vue from "vue";
export default {
  mixins: [mixin],
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
      realImageSrc: "",
      loading: false,
    };
  },
  computed: {
    imageSrcComputed() {
      return this.realImageSrc;
    },
  },
  mounted() {
    this.realImageSrc = this.imageSrc;
  },
  methods: {
    onPickFile() {
      this.$refs.fileInput.click();
    },
    async onFilePicked(event) {
      this.selectedFile = event.target.files[0];
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append("imgFile", this.selectedFile);
        const response = await axios.post("/admin/user/upload-avatar", formData, { headers: { "Content-Type": "multipart/form-data" } });
        this.realImageSrc = response.data.url;
        document.querySelector(".my-user-avatar-preview").src = response.data.url;
          One.helpers(
              'jq-notify',
              {
                  type: 'success',
                  icon: 'fa fa-check me-1',
                  message: 'Your picture has been updated'
              });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
        const vm = new Vue();
        let message = "";
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.message) {
          message = e.response.data.error.message;
        } else if (e.response && e.response.statusText) {
          message = e.response.statusText;
        }
        vm.$bvToast.toast(`Server call returned error: ${message}`, {
          title: `${e.response.statusText} (${e.response.status})`,
          variant: "danger",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-avatar-btn {
  position: relative;
  &.has-loading {
    .upload:after {
      content: "";
      background: white;
      display: block;
    }
  }
  .upload {
    position: absolute;
    top: 3px;
    left: 4px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.5);
    height: 48px;
    width: 48px;
    margin: auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
  .loader {
    position: absolute;
    top: 3px;
    left: 4px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.7);
    height: 48px;
    width: 48px;
    margin: auto;
    border-radius: 50%;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
}
</style>
